<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected stand-division-maintenance-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
            <h5>{{ (localizationKeyPrefix + '.Original.Title') | abpLocalization }} <zn-pill [label]="originalStandChip()"></zn-pill></h5>
            <p>{{ (localizationKeyPrefix + '.Original.Description') | abpLocalization }}</p>
          </div>
          <div class="zn-summary-container">
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Summary.CurrentArea') | abpLocalization }}</p>
              <p class="subtitle">{{ formatArea(originalCurrentArea()) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Summary.AreaAdjustment') | abpLocalization }}</p>
              <p class="subtitle">{{ formatSignedArea(originalAreaDelta()) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Summary.AdjustedArea') | abpLocalization }}</p>
              <p class="subtitle"><zn-pill [label]="formatArea(originalAdjustedArea())"></zn-pill></p>
            </div>
          </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <form class="zn-form" [formGroup]="originalForm">
        <div class="row">
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="originalMaintenancePeriod">
                {{ 'LanguageService::Stand.MaintenancePeriod' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #originalPeriodSelect
                id="originalMaintenancePeriod"
                [options]="periodOptions()"
                [optionsLoader]="loadPeriod"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="period"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('original', 'period')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="originalMaintenanceReason">
                {{ 'LanguageService::Stand.MaintenanceReason' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #originalReasonSelect
                id="originalMaintenanceReason"
                [options]="reasonOptions()"
                [optionsLoader]="loadReason"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="reason"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('original', 'reason')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="originalMaintenanceAdjustmentType">
                {{ 'LanguageService::Stand.AdjustmentType' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #originalAdjustmentTypeSelect
                id="originalMaintenanceAdjustmentType"
                [options]="adjustmentTypeOptions()"
                [optionsLoader]="loadAdjustmentTypes"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="adjustmentType"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('original', 'adjustmentType')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-8">
            <div class="form-control-container">
              <label class="form-label" for="originalMaintenanceDetails">
                {{ 'LanguageService::StandAreaMaintenance.Notes' | abpLocalization }}
              </label>
              <input
                id="originalMaintenanceDetails"
                class="form-control"
                type="text"
                formControlName="details"
                [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label form-check-label" for="originalMaintenanceUpdated">
                {{ `${localizationResource}::Stand.UpdatedArea` | abpLocalization }}
              </label>
              <div class="form-check-inner-container order-first">
                <input
                  id="originalMaintenanceUpdated"
                  class="form-check-input check-lg"
                  type="checkbox"
                  formControlName="isAreaUpdated"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="zn-full-height zn-step-content-section stand-division-maintenance-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="stand-division-maintenance-header stand-division-maintenance-header--stacked">
          <div class="stand-division-maintenance-header-copy">
            <h5>{{ (localizationKeyPrefix + '.New.Title') | abpLocalization }}</h5>
            <p>{{ (localizationKeyPrefix + '.New.Description') | abpLocalization }}</p>
          </div>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <form class="zn-form" [formGroup]="newStandsForm">
        <div class="row">
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="newMaintenancePeriod">
                {{ 'LanguageService::Stand.MaintenancePeriod' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #newPeriodSelect
                id="newMaintenancePeriod"
                [options]="periodOptions()"
                [optionsLoader]="loadPeriod"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="period"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('new', 'period')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="newMaintenanceReason">
                {{ 'LanguageService::Stand.MaintenanceReason' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #newReasonSelect
                id="newMaintenanceReason"
                [options]="reasonOptions()"
                [optionsLoader]="loadReason"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="reason"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('new', 'reason')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              <label class="form-label" for="newMaintenanceAdjustmentType">
                {{ 'LanguageService::Stand.AdjustmentType' | abpLocalization }}
                <span class="form-label-required">*</span>
              </label>
              <zn-single-select
                #newAdjustmentTypeSelect
                id="newMaintenanceAdjustmentType"
                [options]="adjustmentTypeOptions()"
                [optionsLoader]="loadAdjustmentTypes"
                [showSearch]="true"
                [placeholder]="(localizationKeyPrefix + '.SelectPlaceholder') | abpLocalization"
                formControlName="adjustmentType"
                [errorEntityKey]="`${localizationResource}::DefaultErrorRequired`"
                [localizationResource]="localizationResource"
                [openUp]="false"
              ></zn-single-select>
              @if (fieldInvalid('new', 'adjustmentType')) {
                <small class="invalid-feedback d-block">
                  {{ `${localizationResource}::DefaultErrorRequired` | abpLocalization }}
                </small>
              }
            </div>
          </div>
          <div class="col-8">
            <div class="form-control-container">
              <label class="form-label" for="newMaintenanceDetails">
                {{ 'LanguageService::StandAreaMaintenance.Notes' | abpLocalization }}
              </label>
              <input
                id="newMaintenanceDetails"
                class="form-control"
                type="text"
                formControlName="details"
                [placeholder]="`${localizationResource}::EnterText` | abpLocalization"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-control-container">
              
                <label class="form-label form-check-label" for="newMaintenanceUpdated">
                  {{ `${localizationResource}::Stand.UpdatedArea` | abpLocalization }}
                </label>
              <div class="form-check-inner-container order-first">
                <input
                  id="newMaintenanceUpdated"
                  class="form-check-input check-lg"
                  type="checkbox"
                  formControlName="isAreaUpdated"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
